import { Fragment, useState } from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { Divider, MenuItem as MuiMenuItem, Typography } from "@mui/material";

import { useAxios } from "../../../hooks";
import { colors } from "../../../pages/css components/Style";
import AudienceSizeDialog from "./AudienceSizeDialog";
import { alert } from "../../../redux/slices/alertSlice";

const MenuItem = styled(MuiMenuItem)`
  min-width: 200px;
`;

export default function DropDownMenu({
  setMenuAnchor,
  setLoading,
  formikProps,
  audienceSizing,
  setAudienceSizing,
  setIsDownloadAudience,
}) {
  const axios = useAxios();
  const dispatch = useDispatch();

  const [audienceSize, setAudienceSize] = useState({
    state: false,
  });

  return (
    <Fragment>
      <MenuItem onClick={() => downloadAudience()}>
        <Typography variant="h6" color={colors.purple}>
          Download Audience
        </Typography>
      </MenuItem>

      {formikProps.values.permissionSettings?.set_audience_size &&
        formikProps.values.adminApprovalStatus !== "REQUESTED" &&
        formikProps.values.adminApprovalStatus !== "REJECTED" && (
          <Fragment>
            <Divider style={{ marginBlock: 7 }} />
            <MenuItem
              onClick={() => {
                setAudienceSize({
                  ...audienceSize,
                  state: true,
                });
              }}
            >
              <Typography variant="h6" color={colors.purple}>
                Set Audience Size
              </Typography>
            </MenuItem>
          </Fragment>
        )}

      <AudienceSizeDialog
        setMenuAnchor={setMenuAnchor}
        audienceSizing={audienceSizing}
        formikProps={formikProps}
        audienceSize={audienceSize}
        setAudienceSize={setAudienceSize}
        setAudienceSizing={setAudienceSizing}
      />
    </Fragment>
  );

  function downloadAudience() {
    setIsDownloadAudience(true);
    setMenuAnchor(null);

    setLoading((prev) => ({
      ...prev,
      AUDIENCE: true,
    }));
    axios({
      url: "/download/audience/" + formikProps.values.audienceID,
    }).then((response) => {
      if (response.status) {
        window.location.href = response.data;
        dispatch(
          alert({
            type: "success",
            message: "Audience File downloaded successfully!",
          })
        );
      }
      setLoading((prev) => ({
        ...prev,
        AUDIENCE: false,
      }));
      setIsDownloadAudience(false);
    });
  }
}
